module.exports = __webpack_public_path__ + "static/media/rewards_placeholder.b696778b.svg";